export default "__VITE_ASSET__e6529dbc__"